<template>
  <div class="container generalConfig weflix-admin-general">
    <TitlePage title="Configurações Gerais" subtitle="Personalize o sistema Weflix" :hasMargin="false" />
    
    <div class="contetContainerEditVideo" v-if="hasReady">
        <div class="setting-item">
          <div class="setting-header">
            <div class="setting-info">
              <label class="setting-label">Fechamento de carrinho</label>
              <span class="setting-status" :class="cartClosure ? 'active' : 'inactive'">
                {{ cartClosure ? 'Ativado' : 'Inativo' }}
              </span>
            </div>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                v-model="cartClosure"
              />
            </div>
          </div>
        </div>

        <div class="setting-item">
          <div class="setting-header">
            <div class="setting-info">
              <label class="setting-label">Exibir valor parcelado no checkout</label>
              <span class="setting-status" :class="showInstallmentValue ? 'active' : 'inactive'">
                {{ showInstallmentValue ? 'Ativado' : 'Inativo' }}
              </span>
            </div>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                v-model="showInstallmentValue"
              />
            </div>
          </div>
        </div>
    </div>

    <div class="actions configGeneralWeflix px-0">
      <v-btn variant="outlined" border="2" color="primary" size="large" width="140" @click="updateCompany">Salvar</v-btn>
    </div>
  </div>
  
  <div v-if="!hasReady" class="loader-overlay">
    <div class="loader-spinner"></div>
  </div>
</template>

<script>
import apiCompany from '@/utils/Weflix/company';
import { mapState, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
    data(){
        return{
            company: [],
            receivablesAdvance: false,
            mediaComments: false,
            cartClosure: false,
            googleSignIn: false,
            showInstallmentValue: false,
            id: '',
            hasReady: false,
        }
    },
    computed: {
        ...mapState(['token'])
    },
    components: {
        TitlePage
    },
    methods: {
        ...mapActions(['storeCurrentCollections']),

        async getCompany(){
            try {
                const response = await apiCompany.getCompany(this.token);
                this.company = response;
                this.receivablesAdvance = response.anticipation === 1 ? true : false;
                this.mediaComments = response.videoComments === 1 ? true : false;
                this.cartClosure = response.cartStatus === 1 ? true : false;
                this.showInstallmentValue = response.intallmentCheckout === 1 ? true : false;
                this.id = response.id;
                this.hasReady = true;
            } catch (error) {
                console.error(error);
            }
        },
        async updateCompany(){
            this.hasReady = false;
            const payload = {
                "anticipation": this.receivablesAdvance ? 1 : 0,
                "videoComments": this.mediaComments ? 1 : 0,
                "cartStatus": this.cartClosure ? 1 : 0,
                "intallmentCheckout": this.showInstallmentValue ? 1 : 0,
                "name": this.company.name,
            }
            try {
                const response = await apiCompany.editCompany(this.token, payload);
                this.hasReady = true;
                this.notify('Configurações atualizadas com sucesso!', 'success');
            } catch (error) {
                this.notify('Erro ao atualizar configurações!', 'error');
                console.error(error);
            }
        },
        notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
    }, 
    created(){
        this.getCompany();
    }
}
</script>

<style scoped>
.container {
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  height: 100%;
  position: relative;
}

.titleContainer {
  margin-bottom: 30px;
}

.titleContainer h3 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.titleContainer small {
  color: #666;
  font-size: 14px;
}

.settings-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.setting-item {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.2s ease;
  width: 49%;
}
.setting-info {
  text-align: left;
  display: flex;
  gap: 10px;
}
.setting-item:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.setting-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.setting-info {
  flex: 1;
}

.setting-label {
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  display: block;
}

.setting-status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
}

.setting-status.active {
  background-color: #dcfce7;
  color: #166534;
}

.setting-status.inactive {
  background-color: #fef2f2;
  color: #991b1b;
}

.form-check {
  display: flex;
  align-items: center;
  padding: 0;
}

.form-check-input {
  width: 44px;
  height: 24px;
  background-color: #e5e7eb;
  border: none;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
}

.form-check-input:checked {
  background-color: #3b82f6;
}

.form-check-input::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
  top: 2px;
  left: 2px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.form-check-input:checked::before {
  transform: translateX(20px);
}

.actions {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loader-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f4f6;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .container {
    padding: 15px;
  }
  
  .setting-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .contetContainerEditVideo {
    display: flex;
    flex-direction: column;
  }
  .contetContainerEditVideo .setting-item {
    padding: 20px 0px;
  }
  .contetContainerEditVideo .setting-info {
    width: 100%;
    justify-content: space-between;
  }
  .contetContainerEditVideo .setting-status {
    height: fit-content;
  }
  .setting-item {
    width: 100%;
  }
}
.contetContainerEditVideo {
 width: 100%;
 display: flex;
 flex-direction: row;
 gap: 20px;
}
.actions.configGeneralWeflix {
  position: absolute;
  bottom: 24px;
  right: 24px;
}
</style>